import React, { useMemo } from 'react';
import { Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { getGameImages } from '../../../core/helpers/getGameImages';

const MenuBackground = observer(({ x = 0, y = 0 }) => {
  const { menuBackground } = useMemo(() => {
    return getGameImages();
  }, []);

  return <Sprite y={y} x={x} texture={menuBackground} anchor={0.5} alpha={0.45} />;
});

export default MenuBackground;
